import React from "react";
import Tooltip from "@mui/material/Tooltip";
import HistoryIcon from "@mui/icons-material/History";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import PauseIcon from "@mui/icons-material/Pause";
import StopIcon from "@mui/icons-material/Stop";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";

export default function TimeEntryActions({
  entry,
  isPublished,
  isOwnTimecardLocked,
  onEdit,
  update_timecard_status,
  post_time_card_break_end,
  post_time_card_break_start,
  post_time_card_clock_out,
}) {
  // Imported POS entries have external IDs, not native Timecard UUIDs.
  if (entry.is_pos_entry) return null;

  return (
    <>
      {entry.status === "approved" ||
      entry.status === "auto_approved" ||
      entry.status === "denied" ? (
        (() => {
          return (
            <div className="flex space-x-2">
              <Tooltip
                title={
                  isPublished
                    ? "Cannot modify published pay period"
                    : "Revert to pending"
                }
              >
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center ${
                    isPublished
                      ? "bg-slate-100 text-slate-400 cursor-not-allowed"
                      : "bg-slate-100 hover:bg-violet-800 hover:text-white text-violet-700 cursor-pointer"
                  }`}
                  onClick={() => {
                    if (!isPublished) {
                      update_timecard_status([entry.uuid], "pending");
                    }
                  }}
                >
                  <HistoryIcon style={{ fontSize: "18px" }} />
                </div>
              </Tooltip>
            </div>
          );
        })()
      ) : entry.status === "currently_working" ? (
        <div>
          {entry.sub_status === "On Break" ||
          entry.sub_status === "On Paid Break" ? (
            <div className="flex space-x-2">
              <Tooltip
                title={`End break for ${entry.store_team_member.first_name}`}
              >
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center bg-slate-100 ${entry.sub_status === "On Paid Break" ? "hover:bg-blue-600 hover:text-white text-blue-600" : "hover:bg-orange-600 hover:text-white text-orange-600"} cursor-pointer`}
                  onClick={() =>
                    post_time_card_break_end(
                      entry.timecard_breaks?.[entry.timecard_breaks?.length - 1]
                        ?.uuid,
                      Date.now(),
                      entry.store_team_member.id,
                    )
                  }
                >
                  <PlayCircleOutlineIcon
                    style={{
                      fontSize: "18px",
                    }}
                  />
                </div>
              </Tooltip>
              {!isOwnTimecardLocked && (
                <Tooltip title="Edit time entry">
                  <div
                    className="w-8 h-8 rounded-full flex items-center justify-center bg-slate-100 hover:bg-violet-800 hover:text-white text-violet-700 cursor-pointer"
                    onClick={() => {
                      onEdit(entry);
                    }}
                  >
                    <EditIcon style={{ fontSize: "14px" }} />
                  </div>
                </Tooltip>
              )}
            </div>
          ) : (
            <div className="flex space-x-2">
              <Tooltip
                title={`Start break for ${entry.store_team_member.first_name}`}
              >
                <div
                  className="w-8 h-8 rounded-full flex items-center justify-center bg-slate-100 hover:bg-yellow-600 hover:text-white text-yellow-600 cursor-pointer"
                  onClick={() =>
                    post_time_card_break_start(
                      entry.uuid,
                      Date.now(),
                      entry.store_team_member.id,
                    )
                  }
                >
                  <PauseIcon
                    style={{
                      fontSize: "18px",
                    }}
                  />
                </div>
              </Tooltip>
              <Tooltip
                title={`Clock out for ${entry.store_team_member.first_name}`}
              >
                <div
                  className="w-8 h-8 rounded-full flex items-center justify-center bg-slate-100 hover:bg-rose-600 hover:text-white text-rose-600 cursor-pointer"
                  onClick={() =>
                    post_time_card_clock_out(
                      entry.uuid,
                      Date.now(),
                      entry.store_team_member.id,
                    )
                  }
                >
                  <StopIcon
                    style={{
                      fontSize: "18px",
                    }}
                  />
                </div>
              </Tooltip>
              {!isOwnTimecardLocked && (
                <Tooltip title="Edit time entry">
                  <div
                    className="w-8 h-8 rounded-full flex items-center justify-center bg-slate-100 hover:bg-violet-800 hover:text-white text-violet-700 cursor-pointer"
                    onClick={() => {
                      onEdit(entry);
                    }}
                  >
                    <EditIcon style={{ fontSize: "14px" }} />
                  </div>
                </Tooltip>
              )}
            </div>
          )}
        </div>
      ) : (
        (() => {
          return (
            <div className="flex space-x-2">
              <Tooltip
                title={
                  isPublished
                    ? "Cannot modify published pay period"
                    : "Approve time entry"
                }
              >
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center ${
                    isPublished
                      ? "bg-slate-100 text-slate-400 cursor-not-allowed"
                      : "bg-slate-100 hover:bg-emerald-600 hover:text-white text-emerald-800 cursor-pointer"
                  }`}
                  onClick={() => {
                    if (!isPublished) {
                      update_timecard_status([entry.uuid], "approved");
                    }
                  }}
                >
                  <CheckIcon style={{ fontSize: "18px" }} />
                </div>
              </Tooltip>
              <Tooltip
                title={
                  isPublished
                    ? "Cannot modify published pay period"
                    : "Deny time entry"
                }
              >
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center ${
                    isPublished
                      ? "bg-slate-100 text-slate-400 cursor-not-allowed"
                      : "bg-slate-100 hover:bg-rose-700 hover:text-white text-rose-800 cursor-pointer"
                  }`}
                  onClick={() => {
                    if (!isPublished) {
                      update_timecard_status([entry.uuid], "denied");
                    }
                  }}
                >
                  <ClearIcon style={{ fontSize: "18px" }} />
                </div>
              </Tooltip>
              {!isOwnTimecardLocked && (
                <Tooltip
                  title={
                    isPublished
                      ? "Cannot edit published pay period"
                      : "Edit time entry"
                  }
                >
                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center ${
                      isPublished
                        ? "bg-slate-100 text-slate-400 cursor-not-allowed"
                        : "bg-slate-100 hover:bg-violet-800 hover:text-white text-violet-700 cursor-pointer"
                    }`}
                    onClick={() => {
                      if (!isPublished) {
                        onEdit(entry);
                      }
                    }}
                  >
                    <EditIcon style={{ fontSize: "14px" }} />
                  </div>
                </Tooltip>
              )}
            </div>
          );
        })()
      )}
    </>
  );
}
